import { Component, Input, OnInit } from "@angular/core";
import { CommonModule } from "@angular/common";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { ActivatedRoute, Router } from "@angular/router";
import {
  Form,
  FormControl,
  FormGroup,
  Validators,
  FormsModule,
} from "@angular/forms";
import {
  faLinkedinIn,
  faTwitter,
  faInstagram,
  faFacebookF,
} from "@fortawesome/free-brands-svg-icons";
import { AuthService } from "../../services/auth.service";
import { IParametrosBackEnd } from "../../interfaces/IParametrosBackEnd";
import { environment } from "src/environments/environment";

@Component({
  selector: "app-formulario-cadastro",
  templateUrl: "./formulario-cadastro.component.html",
  styleUrls: ["./formulario-cadastro.component.css"],
})
export class FormularioCadastroComponent implements OnInit {
  @Input() tipoConta;

  linkedin = faLinkedinIn;
  facebook = faFacebookF;
  twitter = faTwitter;
  instagram = faInstagram;

  showUsuarioCadastrado: boolean = false;
  showLoginSenhaIncorreta: boolean = false;
  showCadastroError: boolean = false;
  step: string = "cadastro";
  redirect: string = "";
  loading: boolean = false;
  master: boolean = false;
  disableCadastroEmpresa: boolean = false;
  origem: string = "";
  midiaCampanha: string = "";
  nomeCampanha: string = "";
  parametros: IParametrosBackEnd;
  siteUrl: string = "";

  registerData = {
    nome: "",
    cargo: "",
    telefone: "",
    email: "",
    password: "",
    conta: "",
    empresa: "",
    TermosDeUso: false,
  };

  loginData = {
    userName: "",
    password: "",
  };
  nextjobtoken = "";
  nextjobvagaid = "";
  lpti = "";
  lpOrigem: string = "";

  constructor(
    private http: HttpClient,
    private authService: AuthService,
    private router: Router,
    public actRouter: ActivatedRoute
  ) {
    this.siteUrl = environment.serverUrl;
  }

  ngOnInit() {
    this.registerData.conta =
      this.tipoConta != null ? this.tipoConta : "candidato";

    this.actRouter.queryParams.subscribe((params) => {
      this.redirect = params["redirect"];
      this.registerData.empresa = params["idEmpresa"];
      this.master = params["master"];
      this.registerData.nome = params["nome"];
      this.registerData.cargo = params["cargo"];
      this.registerData.email = params["email"];
      this.registerData.conta = params["tipoConta"];
      //console.log("registerData", this.registerData);
      this.showCadastro();
    });

    this.actRouter.params.subscribe((res) => {
      this.parametros = {
        vagaId: res.vagaId,
        redirect: this.redirect,
        origem: this.origem,
        midiaCampanha: this.midiaCampanha,
        nomeCampanha: this.nomeCampanha,
      };
      //console.log("parametros", this.parametros);
    });

    this.actRouter.queryParams.subscribe((params) => {
      if (params["nextjobtoken"]) {
        this.nextjobtoken = params["nextjobtoken"];
        this.redirect = "empresa/#/vaga-novo-fluxo/" + this.nextjobtoken;
        this.parametros = {
          redirect: this.redirect,
          vagaId: "",
          origem: "",
          midiaCampanha: "",
          nomeCampanha: "",
        };
      }

      if (params["nextjobvagaid"]) {
        this.nextjobvagaid = params["nextjobvagaid"];
        this.parametros = {
          redirect: "",
          vagaId: this.nextjobvagaid,
          origem: "nextjob",
          midiaCampanha: "",
          nomeCampanha: "",
        };
      }

      if (params["vagaid"]) {
        if (params["vagaid"]) {
          this.parametros = {
            redirect: "",
            vagaId: params["vagaid"],
            origem: "reachr",
            midiaCampanha: "",
            nomeCampanha: "",
          };
        }
      }

      if (params["lpti"] && params["lp-origin"]) {
        this.lpti = params["lpti"];
        this.lpOrigem = params["lp-origin"];

        if (this.lpOrigem) {
          this.parametros = {
            redirect: "",
            vagaId: this.lpti,
            origem: this.lpOrigem,
            midiaCampanha: "",
            nomeCampanha: "",
          };
        } else {
          localStorage.setItem("ls.vagaId", this.lpti);
          this.redirect = "candidato/#/dashboard";
          this.parametros = {
            redirect: this.redirect,
            vagaId: "",
            origem: "",
            midiaCampanha: "",
            nomeCampanha: "",
          };
        }
      }
      console.log("params", this.parametros);
    });
  }

  setredirect() {
    if (this.redirect) {
      localStorage.setItem("ls.redirect", this.redirect);
    }
  }

  login() {
    this.loading = true;
    this.showUsuarioCadastrado = false;

    let headers = new HttpHeaders().set("Content-Type", "application/json");
    var data =
      "grant_type=password&username=" +
      this.loginData.userName +
      "&password=" +
      this.loginData.password;

    this.http
      .post("https://api.reachr.com.br/token", data, { headers: headers })
      .subscribe(
        (response) => {
          // console.log('RESPONSE', response);
          let item = {
            token: response["access_token"],
            name: response["name"],
            userName: this.loginData.userName,
            refreshToken: "",
            useRefreshTokens: false,
            photoNormal: response["photoNormal"],
            photoThumb: response["photoThumb"],
            perfil: response["perfil"],
            permissoes: response["permissoes"] ? response["permissoes"] : [],
            empresas: response["empresas"] ? response["empresas"] : [],
            socialNetwork: response["socialNetwork"] == "true",
            whiteLabel: response["whiteLabel"],
          };
          localStorage.setItem("ls.authorizationData", JSON.stringify(item));
          this.setredirect();

          let permissoes = response["permissoes"]
            ? JSON.parse(response["permissoes"])
            : [];
          // console.log(permissoes);

          for (var i = 0; i < response["permissoes"].length; i++) {
            if (permissoes[i] == "candidato") {
              if (this.parametros.vagaId) {
                // console.log(this.authService.getUrlCandidato(this.parametros));
                window.location.href =
                  "https://www.reachr.com.br/" +
                  this.authService.getUrlCandidato(this.parametros);
              } else {
                this.router.navigate(["/paracandidatos/cadastro-concluido"]);
              }
            }

            if (permissoes[i] == "empresa") {
              window.location.href =
                "https://www.reachr.com.br/empresa/#/dashboard";
            }
          }
        },
        (err) => {
          console.log(err);
          if (
            err.error.error_description ==
            "The user name or password is incorrect."
          ) {
            this.showUsuarioCadastrado = true;
          }

          if (err.error.error_description == "User did not confirm email.") {
            this.step = "cadastroFinalizado";
          }

          this.loading = false;
        }
      );
  }

  criarContaEmpresa() {
    var data_array = {
      nome: this.registerData.nome,
      email: this.registerData.email,
      telefone: this.registerData.telefone,
      cargo: this.registerData.cargo,
      nomeEmpresa: this.registerData.empresa,
      identificador: "Novo cadastro - Empresa",
      token_rdstation: "79f4216f04f18501d511df7321d84f9e",
    };

    let url = "https://www.rdstation.com.br/api/1.3/conversions";
    let headers = new HttpHeaders().set("Content-Type", "application/json");

    // desabilitado a pedido da Márcia em 31/03/2021
    // this.http.post(url, data_array, { headers: headers })
    // .subscribe((response) => {
    //   console.log('lead registrado');
    // }, err => {
    //   console.log(err);
    // });

    //Register
    let data = {
      Nome: this.registerData.nome,
      Name: this.registerData.nome,
      Empresa: this.registerData.empresa,
      Cargo: this.registerData.cargo,
      Telefone: this.registerData.telefone,
      Password: this.registerData.password,
      ConfirmPassword: this.registerData.password,
      Gender: "",
      Username: this.registerData.email,
      UserName: this.registerData.email,
      Email: this.registerData.email,
    };

    this.http
      .post("https://api.reachr.com.br/api/account/RegisterPJ", data, {
        headers: headers,
      })
      .subscribe(
        (response) => {
          this.loginData.userName = this.registerData.email;
          this.loginData.password = this.registerData.password;
          console.log("conta criada pj");
          this.login();
        },
        (err) => {
          console.log(err);

          if (err.error.modelState) {
            console.log(err.error.modelState.Errors[0].ErrorMessage);
            if (
              err.error.modelState.Errors[0].ErrorMessage ==
              "Não foi possível efetuar o cadastrado."
            ) {
              this.showUsuarioCadastrado = true;
              this.showCadastroError = false;
            }
          } else {
            console.log(err.error);
            this.showUsuarioCadastrado = false;
            this.showCadastroError = true;
          }
        }
      );
  }

  criarContaCandidato() {
    let headers = new HttpHeaders().set("Content-Type", "application/json");

    let data = {
      Nome: this.registerData.nome,
      Name: this.registerData.nome,
      Telefone: this.registerData.telefone,
      Password: this.registerData.password,
      ConfirmPassword: this.registerData.password,
      Username: this.registerData.email,
      Email: this.registerData.email,
      UserName: this.registerData.email,
      TermosDeUso: true,
      WhiteLabel: "Site Principal",
      Empresa: "",
      Gender: "",
      EmailConfirmed: true,
      Cargo: "",
    };

    this.http
      .post(
        "https://api.reachr.com.br/api/account/register?EmailConfirmed=true",
        data,
        { headers: headers }
      )
      .subscribe(
        (response) => {
          this.loginData.userName = this.registerData.email;
          this.loginData.password = this.registerData.password;
          this.login();
          console.log("conta criada pf");
        },
        (err) => {
          console.log(err);
          this.showUsuarioCadastrado = true;
        }
      );
  }

  showCadastro() {
    if (
      (this.registerData.empresa &&
        this.registerData.nome &&
        this.registerData.email &&
        this.registerData.conta) ||
      this.registerData.conta
    ) {
      this.disableCadastroEmpresa = true;
    }
  }

  validarJuridico() {
    if (
      this.registerData.nome != "" &&
      this.registerData.email != "" &&
      this.registerData.password != "" &&
      this.registerData.telefone != null &&
      this.registerData.empresa != "" &&
      this.registerData.cargo != "" &&
      this.registerData.TermosDeUso == true
    ) {
      return true;
    } else {
      return false;
    }
  }

  validarFisico() {
    if (
      this.registerData.nome != "" &&
      this.registerData.email != "" &&
      this.registerData.password != "" &&
      this.registerData.telefone != null &&
      this.registerData.TermosDeUso == true
    ) {
      return true;
    } else {
      return false;
    }
  }

  salvarParametros() {
    localStorage.setItem(
      "parametros-vaga-login-linkedin",
      JSON.stringify(this.parametros)
    );
    //console.log("params-linkedin: ", this.parametros);
    sessionStorage.setItem("linkedin-redirect", this.tipoConta);
    console.log(this.tipoConta, sessionStorage.getItem("linkedin-redirect"));
  }
}
